<template>
    <div>
      <div class="card">
        <header class="bandeau-modal card-header">
        </header>
        <div class="center pd-10px">
          <div class="columns is-gapless">
            <div class="column mgt-20px">
              <h1 class="title is-size-3">{{ $t('optionBlocage.popUpModification.title') }}</h1>
            </div>
          </div>
        </div>
        <div class="card-content">
          <b-select expanded v-model="newEtat">
            <option v-for="status in etatSouhaite"
                    :key="status.key"
                    :value="status.key">
              {{$t(status.libelle)}}
            </option>
          </b-select>
        </div>
        <div class="card-content has-text-centered">
          <button class="button btn-modal-annuler is-cancel pdh-20px" @click="$parent.close">
            {{ $t('optionBlocage.popUpModification.cancel') }}
          </button>
          <button class="button is-addOrEdit mgl-10px" @click="$emit('newEtat', newEtat)">
            {{ $t('optionBlocage.popUpModification.edit') }}
          </button>
        </div>
      </div>
    </div>
</template>

<script>
import { ETAT_SOUHAITE, AUCUN } from '@/configuration/optionBlocage/optionBlocage';

export default {
  name: 'p_modificationEtatSouhaite',
  data() {
    return {
      newEtat: AUCUN,
      etatSouhaite: ETAT_SOUHAITE,
    };
  },
};
</script>

<style scoped>

</style>
